import { createContext, useContext } from 'react'

export interface ModalTitleContextValue {
  titleId: string
  /** Makes `id` the modal's accessible name until the returned cleanup runs. */
  registerTitle(id: string): () => void
}

export const ModalTitleContext = createContext<ModalTitleContextValue | undefined>(undefined)

if (process.env.NODE_ENV !== 'production') {
  ModalTitleContext.displayName = 'ModalTitleContext'
}

export const useModalTitleContext = () => useContext(ModalTitleContext)
